class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if ($('form[data-type="add-to-cart-form"] input[name="id"]').val() == "") {
      $('.select-selected').addClass('error');
      return
    }
    this.cartNotification.setActiveElement(document.activeElement);
    const submitButton = this.querySelector('[type="submit"]');

    // submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        checkBubbleCart()
      });
  }
}

function checkBubbleCart() {
  if ($(window).width() <= 750) {
    $('#cart-icon-bubble').addClass('full-cart')
  } else {
    $('#cart-icon-bubble').removeClass('full-cart')
  }
  if (!$('#cart-icon-bubble .cart-count-bubble').length) {
    $('#cart-icon-bubble').removeClass('full-cart')
  }
}
customElements.define('product-form', ProductForm);
